import { jsx as e } from "react/jsx-runtime";
import { Box as t, Icon as n } from "@dixa/lib-shared-habla";
//#region ../utils/src/colors.ts
function r(e) {
	return e.length === 9 ? e.slice(0, 7) : e;
}
//#endregion
//#region ../utils/src/constants.ts
var i = "#45587C", a = { collectionIcon: "_collectionIcon_10v8g_1" };
//#endregion
//#region ../delivery-common/src/components/collectionIcon.tsx
function o({ color: o = i }) {
	let s = r(o);
	return /* @__PURE__ */ e(t, {
		as: "span",
		style: { backgroundColor: `${s}1A` },
		borderRadius: "100",
		children: /* @__PURE__ */ e(n, {
			name: "copy",
			size: 20,
			className: a.collectionIcon,
			style: {
				fill: s,
				color: s
			}
		})
	});
}
//#endregion
export { o as t };

//# sourceMappingURL=collectionIcon-Be4I1YBb.js.map